import * as React from "react";
import { useState } from "react";
import { ComboBox } from "react-ui";

import { FiasRegion } from "../../../../FiasInput/Types/FiasTypes";
import { getRegionByCode } from "../../../../FiasInput/Utils/Convertations/Region/Region";
import { Caption, Row, Value } from "../../FiasFnsManualEditor.styles";
import { FiasApi } from "../../../../FiasInput/FiasApi";
import { useAsyncEffect } from "../../../../../../../../../Common/UseAsyncEffect";
import { isRegionMatchToFilterString } from "../FiasFnsManualEditorUtils";

interface RegionProps {
    value: string | undefined;
    onValueChange: (next: string) => void;
    apiClient: FiasApi;
}

export function Region({ value, onValueChange, apiClient }: RegionProps): JSX.Element | null {
    const [selectedRegion, setSelectedRegion] = useState<FiasRegion | undefined>(undefined);

    useAsyncEffect(async () => {
        if (value) {
            const region = await getRegionByCode(value, apiClient);
            setSelectedRegion(region);
        } else {
            setSelectedRegion(undefined);
        }
    }, [value]);

    return (
        <Row>
            <Caption>Регион</Caption>
            <Value>
                <ComboBox<FiasRegion>
                    width={350}
                    getItems={async query => {
                        const regionsList = await apiClient.fetchRegions();
                        return regionsList
                            .map(x => x.region)
                            .filter(x => isRegionMatchToFilterString(x, query))
                            .slice(0, 10);
                    }}
                    value={selectedRegion}
                    renderItem={item => `${item.name} ${item.abbreviation}.`}
                    renderValue={item => `${item.name} ${item.abbreviation}.`}
                    valueToString={item => item?.name}
                    onUnexpectedInput={() => onValueChange("")}
                    onValueChange={nextRegion => onValueChange(nextRegion.code?.substring(0, 2) ?? "")}
                    drawArrow={false}
                    data-tid={"Region"}
                />
            </Value>
        </Row>
    );
}
